"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledCheckboxGroup = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _checkableInput = require("../../__internal__/checkable-input/checkable-input.style");

var _fieldHelp = _interopRequireDefault(require("../../__internal__/field-help/field-help.style"));

var _hiddenCheckableInput = _interopRequireDefault(require("../../__internal__/checkable-input/hidden-checkable-input.style"));

var _checkableInputSvgWrapper = _interopRequireDefault(require("../../__internal__/checkable-input/checkable-input-svg-wrapper.style"));

var _label = _interopRequireWildcard(require("../../__internal__/label/label.style"));

var _validationIcon = _interopRequireDefault(require("../../__internal__/validations/validation-icon.style"));

var _formField = _interopRequireDefault(require("../../__internal__/form-field/form-field.style"));

var _icon = _interopRequireDefault(require("../icon/icon.style"));

var _base = _interopRequireDefault(require("../../style/themes/base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const CheckboxStyle = _styledComponents.default.div`
  ${_styledSystem.margin}
  ${({
  disabled,
  error,
  warning,
  info,
  fieldHelpInline,
  labelSpacing,
  inputWidth,
  reverse,
  size,
  adaptiveSpacingSmallScreen,
  theme
}) => (0, _styledComponents.css)`
    ${adaptiveSpacingSmallScreen && "margin-left: 0;"}

    ${_checkableInput.StyledCheckableInput} {
      padding-top: 1px;
    }

    ${_checkableInputSvgWrapper.default} {
      height: 16px;
    }

    svg {
      background-color: ${theme.colors.white};
      ${!disabled && (0, _styledComponents.css)`
        border: 1px solid ${theme.colors.border};

        ${info && `border: 1px solid ${theme.colors.info};`}
        ${warning && `border: 1px solid ${theme.colors.warning};`}
        ${error && `border: 2px solid ${theme.colors.error};`}
      `}
    }

    ${_hiddenCheckableInput.default},
    svg {
      height: 16px;
      position: absolute;
      padding: 1px;
    }

    ${_checkableInput.StyledCheckableInput},
    ${_hiddenCheckableInput.default},
    ${_checkableInputSvgWrapper.default},
    svg {
      box-sizing: border-box;
      min-width: 16px;
      width: 16px;
    }

    // prettier-ignore
    ${_hiddenCheckableInput.default}:not([disabled]) {
      &:focus + ${_checkableInputSvgWrapper.default},
      &:hover + ${_checkableInputSvgWrapper.default} {
        box-shadow: 0 0 0 3px ${theme.colors.focus};
      }
    }

    ${_label.StyledLabelContainer} {
      width: auto;
      flex: 0 1 auto;
    }

    ${_fieldHelp.default} {
      margin-left: 16px;
      margin-top: 0;
      padding-left: ${labelSpacing * theme.spacing}px;
    }

    ${_validationIcon.default} {
      position: relative;
      display: inline-block;
    }

    ${size === "large" && (0, _styledComponents.css)`
      ${_checkableInputSvgWrapper.default} {
        height: 24px;
      }

      ${_checkableInput.StyledCheckableInput},
      ${_hiddenCheckableInput.default},
      ${_checkableInputSvgWrapper.default},
      svg {
        height: 24px;
        width: 24px;
      }

      ${_fieldHelp.default} {
        margin-left: 24px;
        padding-left: ${labelSpacing * theme.spacing}px;
      }

      ${fieldHelpInline && (0, _styledComponents.css)`
        ${_fieldHelp.default}, ${_label.StyledLabelContainer} {
          align-self: center;
        }
      `}
    `}

    ${_hiddenCheckableInput.default}:checked ~ ${_checkableInputSvgWrapper.default} svg path {
      fill: ${theme.checkable.checked};
    }

    ${disabled && (0, _styledComponents.css)`
      svg {
        background-color: ${theme.disabled.input};
        border: 1px solid ${theme.disabled.border};
      }

      svg path {
        fill: ${theme.disabled.input};
      }

      ${_hiddenCheckableInput.default}:checked ~ ${_checkableInputSvgWrapper.default} svg path {
        fill: ${theme.disabled.border};
      }

      ${_checkableInputSvgWrapper.default} {
        &:hover,
        &:focus {
          outline: none;
          cursor: not-allowed;
        }
      }
    `}

    ${fieldHelpInline && `
      ${_fieldHelp.default} {
        margin-left: 0;
      }

      ${_label.default} {
        flex: 0 1 auto;
      }
    `}

    ${inputWidth !== undefined && inputWidth !== 0 && `
      ${_fieldHelp.default} {
        ${reverse ? "margin-right" : "margin-left"}: ${inputWidth}% !important;
      }
    `}

    ${reverse && (0, _styledComponents.css)`
      ${_fieldHelp.default} {
        margin-left: 0;
        padding-left: 0;
      }

      ${_label.default} {
        flex: 0 1 auto;
      }

      ${fieldHelpInline && (0, _styledComponents.css)`
        ${_checkableInput.StyledCheckableInput} {
          margin-right: 8px;
        }

        ${_fieldHelp.default} {
          padding-left: 6px;
        }
      `}
    `}
  `}
`;
CheckboxStyle.defaultProps = {
  theme: _base.default
};
CheckboxStyle.propTypes = {
  disabled: _propTypes.default.bool,
  error: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  warning: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  info: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  fieldHelpInline: _propTypes.default.bool,
  inputWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  labelWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  size: _propTypes.default.string
};
const StyledCheckboxGroup = _styledComponents.default.div`
  display: flex;
  flex-direction: column;

  ${_icon.default}::before {
    font-size: 16px;
  }

  & ${CheckboxStyle} {
    padding-top: 12px;
  }

  & > ${_formField.default} {
    & > ${_label.StyledLabelContainer} {
      margin-bottom: 4px;
      vertical-align: middle;

      ${_validationIcon.default} {
        display: inline-block;
      }
    }
  }

  ${({
  legendInline
}) => legendInline && (0, _styledComponents.css)`
      ${CheckboxStyle}:first-child {
        padding-top: 4px;
      }
    `}
`;
exports.StyledCheckboxGroup = StyledCheckboxGroup;
StyledCheckboxGroup.defaultProps = {
  theme: _base.default
};
var _default = CheckboxStyle;
exports.default = _default;